import Preloader from "@/components/dashboard/preloader/Preloader";
import { useAuth } from "@/context/AuthContext";
import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";

export default function RequireAuth() {
  const { ready, isAuthenticated } = useAuth();
  const redirected = useRef(false);

  useEffect(() => {
    if (!ready || isAuthenticated || redirected.current) return;
    redirected.current = true;
    window.location.replace("/login");
  }, [ready, isAuthenticated]);

  if (!ready) {
    return <Preloader />;
  }
  if (!isAuthenticated) {
    return <Preloader />;
  }
  return <Outlet />;
}
